module.exports = __webpack_public_path__ + "images/premium1-f3d9f27198e9965f7add984863acf22d.jpg";